var hexToRGBA=function(r,e){var n=r.replace("#","");return"rgba("+parseInt(n.substring(0,2),16)+", "+parseInt(n.substring(2,4),16)+", "+parseInt(n.substring(4,6),16)+", "+e+")"};export{hexToRGBA};
//# sourceMappingURL=HexToRGBA.js.map
